import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ThemeProvider from './theme/ThemeProvider';
import HomePage from './pages/HomePage';
import ShopPage from './pages/ShopPage';
import SpinHistoryPage from './pages/SpinHistoryPage';
import OrdersHistoryPage from './pages/OrdersHistoryPage';
import ReferralPage from './pages/ReferralPage';
import BuyBonusPage from './pages/BuyBonusPage';
import PopularityStorePage from './pages/PopularityStorePage';
import BottomNavigationComponent from './components/navigation/BottomNavigation';
import JustWheelPage from './pages/JustWheelPage';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { UserProvider } from './contexts/UserContext';
import { BotStateProvider } from './contexts/BotStateContext';
import AuthGuard from './components/auth/AuthGuard';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const App: React.FC = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <UserProvider>
          <BotStateProvider>
            <AuthGuard>
              <Router>
                <div className="App">
                  <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/shop" element={<ShopPage />} />
                    <Route path="/bonus" element={<BuyBonusPage />} />
                    <Route path="/popularity" element={<PopularityStorePage />} />
                    <Route path="/orders/history" element={<OrdersHistoryPage />} />
                    <Route path="/referral" element={<ReferralPage />} />
                    <Route path="/spin" element={<JustWheelPage />} />
                    <Route path="/spin-history" element={<SpinHistoryPage />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                  </Routes>
                  <BottomNavigationComponent />
                </div>
              </Router>
            </AuthGuard>
          </BotStateProvider>
        </UserProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
};

export default App;
